export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-heading text-primary-400 mb-4">暗网吃瓜</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                暗网吃瓜是全网领先的黑料爆料与隐秘八卦聚合平台，每日更新吃瓜速递、真实吃瓜事件和最新爆料，为吃瓜群众提供最及时的娱乐资讯和独家深扒内容。
              </p>
            </div>

            <div>
              <h3 className="text-sm font-medium text-foreground-700 mb-4">快速导航</h3>
              <ul className="space-y-2">
                <li><a href="#updates" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">吃瓜速递</a></li>
                <li><a href="#cards" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">热门爆料</a></li>
                <li><a href="#media" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">爆料现场</a></li>
                <li><a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">热度榜单</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-medium text-foreground-700 mb-4">热门话题</h3>
              <ul className="space-y-2">
                <li><a href="#topics" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">娱乐圈黑料</a></li>
                <li><a href="#topics" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">网红翻车</a></li>
                <li><a href="#topics" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">综艺内幕</a></li>
                <li><a href="#topics" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors">社会热点</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-medium text-foreground-700 mb-4">合作伙伴</h3>
              <p className="text-sm text-foreground-500">
                更多合作方即将揭晓
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 暗网吃瓜. 本站内容仅供娱乐参考.
            </p>
            <p className="text-xs text-foreground-400">
              黑料爆料 · 隐秘八卦 · 真实吃瓜 · 吃瓜速递
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}